const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/oauth-clients/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/common/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/settings/oauth-clients/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings.oauthClients.title)
    }
  }
});